import { render, staticRenderFns } from "./ProjectRoute.vue?vue&type=template&id=7f4ae220"
import script from "./ProjectRoute.vue?vue&type=script&lang=ts"
export * from "./ProjectRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4ae220')) {
      api.createRecord('7f4ae220', component.options)
    } else {
      api.reload('7f4ae220', component.options)
    }
    module.hot.accept("./ProjectRoute.vue?vue&type=template&id=7f4ae220", function () {
      api.rerender('7f4ae220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/ProjectRoute.vue"
export default component.exports